import React, { createContext, useContext, useState } from 'react';
import UploaderAddDialog from './UploaderAddDialog';

const UploaderAddDialogContext = createContext();
export const useUploaderAddDialog = () => useContext(UploaderAddDialogContext);

function UploaderAddDialogProvider(props) {
    const { children, fileSystemNodePath } = props;

    const [ isUploaderAddDialogOpen, setIsUploaderAddDialogOpen ] = useState(false);
    const [ files, setFiles ] = useState([]);

    const open = (files) => {
        setFiles(files);
        setIsUploaderAddDialogOpen(true);
    }

    return (
        <UploaderAddDialogContext.Provider value={{ open }}>
            {children}
            <UploaderAddDialog open={isUploaderAddDialogOpen} files={files} fileSystemNodePath={fileSystemNodePath} handleCancel={() => {setIsUploaderAddDialogOpen(false)}}/>
        </UploaderAddDialogContext.Provider>
    );
}
export default UploaderAddDialogProvider;